module.exports = __webpack_public_path__ + "img/SK35964693.0f279ffe.png";